<div [innerHTML]="renderContent(amount) | safeHtml"></div>
